import { render } from "./ChinaMap.vue?vue&type=template&id=5137fc02&scoped=true"
import script from "./ChinaMap.vue?vue&type=script&lang=js"
export * from "./ChinaMap.vue?vue&type=script&lang=js"

import "./ChinaMap.vue?vue&type=style&index=0&id=5137fc02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5137fc02"]])

export default __exports__